<template>
  <div>
    <h2>Welcome</h2>

    <div
      v-if="
        lists_by_pk &&
        lists_by_pk.link_sharing &&
        lists_by_pk.status == 'active'
      "
    >
      <div>A new subject to brainstorm is waiting for you:</div>
      <b>{{ lists_by_pk.title }}</b>

      <empty-state
        v-bind:description="'You are in the right place! Ready to join a new brainstorming session!'"
        :image="'undraw_join.svg'"
        v-bind:callToAction="'Join list'"
        v-bind:act="setListIdEncoded"
        v-bind:primary="true"
      ></empty-state>
    </div>

    <empty-state
      v-if="
        lists_by_pk &&
        !lists_by_pk.link_sharing &&
        lists_by_pk.status == 'active'
      "
      v-bind:description="'We are sorry, but this link is blocked. You can ask to the owner of the session to unlock it'"
      :image="'undraw_security.svg'"
    ></empty-state>

    <empty-state
      v-if="!lists_by_pk"
      v-bind:description="'We are sorry, but this link is not valid...'"
      :image="'undraw_lost.svg'"
    ></empty-state>
  </div>
</template>

<script>
import UuidEncoder from "uuid-encoder";

import EmptyState from "../components/EmptyState";

import api from "../api";
import bus from "../bus";

import getList from "../gql/lists/getList.gql";

export default {
  components: {
    EmptyState,
  },
  data() {
    return {
      listIdEncoded: this.$route.params.listIdEncoded,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    listIdDecoded() {
      const encoder = new UuidEncoder("base36");
      return encoder.decode(this.listIdEncoded);
    },
  },
  apollo: {
    lists_by_pk: {
      query: getList,
      variables() {
        return {
          list_id: this.listIdDecoded,
        };
      },
      error() {},
      result() {
        bus.$emit("hide-loader");
      },
    },
  },
  methods: {
    setListIdEncoded: function () {
      if (this.lists_by_pk.link_sharing) {
        localStorage.setItem("list-id-invited-code", this.listIdEncoded);

        if (this.user) {
          api.addUserToList(this.listIdDecoded, this.user.id, "active");
          localStorage.removeItem("list-id-invited-code");
        }

        this.$router.push("/lists/" + this.listIdDecoded);
      }
    },
  },
  beforeMount() {
    bus.$emit("show-loader", "");
  },
};
</script>

<style scoped lang="scss">
@use '../styles/theme.scss';
</style>